import React from 'react'

const Features = () => {
  return (
   <main> 
      <section className='bg-[#F3F6FD]'> 
          <div className='container mx-auto  xl:max-w-[1280px] px-4 md:px-6  '>
              <div className='grid lg:grid-cols-2'> 
                    <div className=' mt-10 md:mt-20'> 
                      {/* <h1 className='text-xl sm:text-2xl sm:text-center lg:text-start font-semibold text-textgray'> Features  </h1> */}
                      <h1 className='font-bold text-xl  text-center lg:text-start sm:text-3xl  md:text-5xl xl:text-5xl lg:mt-10 lg:w-full md:w-10/12 md:mx-auto'> More ways <br/> to stay connected</h1>
                      <p className='lg:w-10/12 mt-4 text-textgray text-[0.9rem] sm:text-lg lg:text-base text-center lg:text-start'> Enjoy an elevated experience with MS lockdown, we guarantee you a safe space to have the best private online interactions through our secure systems. You can share photos, and videos  and also Message your friends and family for free.  Customize your profile to match your status and personality. This is not just another chat app, but it is built with our user’s interest in mind </p>
                      {/* <img className='absolute top-[17rem] sm:top-[20rem] w-[12rem]  lg:top-[19rem] lg:ml-20  lg:w-[18rem] ' src='./image/shade.png' alt='' /> */}
                  </div>

                  <div> 
                      <div className='mt-10'>
                          <img className='md:max-w-[35rem] mx-auto w-full lg:ml-auto  ' src='./image/connected.webp' alt=''/>  
                      </div>
                  </div>
              </div>
          </div> 
      </section>


       <section > 
          <div className='container mx-auto  xl:max-w-[1280px] px-4 md:px-6 mb-10 '>
              <div className='lg:grid flex flex-col-reverse lg:grid-cols-2 pt-10 lg:pt-16'> 
                  <div> 
                      <div>
                          <img className='md:max-w-[35rem] mx-auto w-full lg:mx-0 lg:ml-[-70px]' src='./image/voice.webp' alt=''/> 
                          {/* <img className='absolute w-[20rem] top-[50rem] ' src='./image/sideshade.png' alt='' /> */}
                           <p className='lg:hidden mt-[-2rem] text-xl text-[0.9rem] text-center sm:text-lg '> Create and enjoy wonderful new experiences through our video chat feature, this feature gives you confidence to see the world through other people's eyes. Missing your loved ones? Spend hours talking to family, friends or associates in different time zones.  </p> 
                      </div>
                  </div>

                    <div className=' text-center lg:text-start'> 
                      {/* <h1 className='text-2xl sm:text-2xl sm:text-center lg:text-start font-semibold text-textgray'> Video call and Voice Call  </h1> */} 
                     
                      <h1 className='font-bold sm:text-center lg:text-start text-xl sm:text-3xl md:text-4xl xl:text-5xl lg:mt-20 lg:w-full md:w-10/12 md:mx-auto'> Enjoy Voice & Video calls with Everyone</h1>
                      <p className='hidden lg:flex mt-4  sm:text-lg'> Create and enjoy wonderful new experiences through our video chat feature, this feature gives you confidence to see the world through other people's eyes. Missing your loved ones? Spend hours talking to family, friends or associates in different time zones.  </p>
                  </div>
              </div>
          </div> 
      </section>

       <section className='bg-[#F3F6FD] '> 
          <div className='container mx-auto  xl:max-w-[1280px] px-4 md:px-6   '>
              <div className='grid lg:pt-12  lg:grid-cols-2'> 
                    <div className='pt-10 lg:mt-16'> 
                      {/* <h1 className='text-lg sm:text-2xl sm:text-center lg:text-start font-semibold text-textgray'> Engage friends with Chats </h1> */}
                      <h1 className='font-bold text-center lg:text-start text-xl sm:text-3xl md:text-4xl xl:text-5xl mt-4 lg:w-full md:w-10/12 md:mx-auto'> Express yourself using our chat feature</h1>
                      <p className='lg:flex md:text-lg hidden  mt-4'> Enjoy our exciting chat features including stickers, emoji's and Giphy. Spark meaningful conversations with your loved ones and new connections. See what is happening in real time and join the conversation by commenting, liking and tagging friends to your favorite post.  </p>
                  </div>

                  <div> 
                      <div>
                          <img className='md:max-w-[35rem] mx-auto w-full lg:ml-auto' src='./image/express.webp' alt=''/>  
                           <p className='lg:hidden mb-10 text-[0.9rem] sm:text-lg text-center'> Enjoy our exciting chat features including stickers, emoji's and Giphy. Spark meaningful conversations with your loved ones and new connections. See what is happening in real time and join the conversation by commenting, liking and tagging friends to your favorite post.  </p>
                      </div>
                  </div>
              </div>
          </div> 
      </section>

      <section> 
          <div className='container mx-auto  xl:max-w-[1280px] px-4 md:px-6 mb-10 '>
              <div className='lg:grid flex flex-col-reverse lg:grid-cols-2 mt-10'> 
                  <div> 
                      <div>
                          <img className='md:max-w-[35rem] h-[24rem] sm:h-[27rem] w-[24rem] md:h-[28rem] md:w-[25rem]   mt-10  mx-auto ' src='./image/Group.webp' alt=''/> 
                           <p className='lg:hidden sm:text-lg text-[0.9rem] text-center mt-10 '> Memories are meant to be shared. With Mslockdown, share photos, videos and sneak peaks of priceless moments and adventures with your loved ones and friends from all around the world.   </p> 
                      </div>
                  </div>

                    <div className='lg:mt-20 '> 
                      {/* <h1 className='text-lg sm:text-2xl sm:text-center lg:text-start font-semibold text-textgray'> PHOTOS AND VIDEOS  </h1> */}
                      <h1 className='font-bold text-center lg:text-start lg:mt-10 text-xl sm:text-3xl md:text-4xl xl:text-5xl lg:w-full md:w-10/12 md:mx-auto '> Share Exciting Moments with Photos and Videos </h1>
                      <p className='hidden lg:flex mt-4 md:text-lg'> Memories are meant to be shared. With Mslockdown, share photos, videos and sneak peaks of priceless moments and adventures with your loved ones and friends from all around the world.  </p>
                  </div>
              </div>
          </div> 
      </section>
   </main>
  )
}

export default Features